<template>
  <div id="app" ref="app">
    <Menu/>
    <Slide
      @closeMenu="handleCloseMenu"
      class="menu-button"
      :closeOnNavigation="true"
    >
      <router-link v-for="(name, route) in routerLinks" :key="route" class="menu-item" :to="route">{{ loc.menu[name] }}</router-link>
    </Slide>
    <main id="page-wrap">
      <Navbar :router-links="routerLinks" :transparent="currentRoute === 'home'"/>
      <router-view/>
      <Copyright/>
    </main>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu"
import Copyright from "./components/Copyright"
import Navbar from "./components/Navbar"

export default {
  components: {
    Slide, // Register your component
    Copyright,
    Navbar,
  },
  data() {
    return {
      routerLinks: {
        "/": "homepage",
        "/production": "products",
        "/samples": "examples",
        "/assembly": "assembly",
        "/contact": "contact",
      },
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    },
  },
  methods: {
    handleCloseMenu() {
      this.$refs.app.style = null
    },
  },
}
</script>

<style lang="less">
  @import "styles/colors";
  @import "styles/fonts";

  html {
    background-color: @base;
  }

  body {
    margin: 0px !important;
    background-color: @base;
  }
#app {
  font-family: @text;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

  main {
    height: 100% !important;
    margin: 0px !important;
    margin-top: -21px !important;
  }
  .menu-item {
    color: @base !important;
    padding: 13% !important;
    margin-bottom: 30px;
    font-size: 30px;
    white-space: nowrap;
  }
  .menu-item:hover .route-name{
    border-bottom: 1.5px solid;
  }
  @media screen and (min-width: 1199px) {
    .menu-button {
      display: none;
    }
  }
  @media screen and (max-width: 1199px) {
    .navbar {
      display: none !important;
    }
    .helper-navbar {
      display: none !important;
    }
    .menu-item:hover {
      color: @lighter !important;
    }
  }
</style>
